import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteFeedbackApi = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.DELETE_FEEDBACK_BY_ID,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteFeedbackApi
